import React, { useCallback } from 'react';
import SkillsMatrixList from '../SkillsMatrixList';
import { skillsApi } from '../../../services/api';

const SkillsMatrixTemplates = () => {
  // Create stable reference for the fetch function
  const fetchMatricesFunction = useCallback(async () => {
    return await skillsApi.getAllSkillsMatrices();
  }, []);

  return (
    <SkillsMatrixList
      title="Skills Matrix Templates"
      backButtonText="Back to Skills Matrix"
      backButtonPath="/skills-matrix"
      fetchMatricesFunction={fetchMatricesFunction}
      allowCRUD={true}
      allowAdd={true}
      allowEdit={true}
      allowDelete={true}
      allowManageVersions={true}
      showCopyTemplate={true}
      searchPlaceholder="Search Matrix Templates"
      addButtonText="Add Matrix Template"
      addButtonColor="#2563eb"
      emptyStateTitle="No matrix templates found"
    />
  );
};

export default SkillsMatrixTemplates; 